import { useQuery } from '@tanstack/react-query';
import { customerService } from '../../../services/api';

export const useCustomerDetailsQuery = (id) => {
  return useQuery({
    queryKey: ['customer-details', id],
    queryFn: () => customerService.getContact(id).then((res) => res.data),
    enabled: !!id,
    staleTime: 30_000,
    gcTime: 120_000,
    refetchInterval: 60_000,
  });
};
